<template>
  <div>

    <div class="center_block">

      <div class="banner">
        <div>
          <div class="first-logo_wrapper">
            <div class="first-logo" style="max-width: 420px">
              <div style="display:flex;justify-content: center;">
                <span>экосистема</span>
              </div>
              <div style="display:flex;justify-content:center;">
                <img src="https://netwiz.ru/local/templates/main/img/Netwiz_logo.png" style="width: 80%;">
              </div>
            </div>
          </div>
          <div class="first-text" style="text-align: center">
            <p>Поиск товаров и услуг</p>
          </div>
        </div>
      </div>

      <div
          :class="{'content': true}"
          :style="(!$route.query.search) ? 'max-width: none' : ''">
        <div class="search-field" style="margin: 0 auto;max-width:700px; padding-top: 15px">

          <div class="search__content">

            <SearchForm
                @submit="onSearchSubmit"
                v-model="searchInput"
                @input="onSearchInput"
                @focusin="onInputFocusin"
                @focusout="onInputFocusOut"
                :icons="search_icons"
            />

            <div class="banner_text">
              <a v-for="(service,index) in services" :key="index" class="thumb shine" :href="service.href" target="_blank">
                <img :src="service.img" :alt="service.name" draggable="false">
                <span>{{ service.name }}</span>
              </a>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import SearchForm from "@/components/SearchForm";
import Services from "@/data/services.json";
import search_icons from "@/data/search_icons.json"

export default {
  name: 'Home',
  data() {
    return {
      services: Services,
      searchInput: "",
      blurHead: false,
      inputFocused: false,
      search_icons: search_icons
    }
  },
  head: {
    title() {
      return {
        inner: 'netwiz - интернет-экосистема',
      }
    }
  },
  methods: {

    onInputFocusin(){
      this.blurHead = true;
      this.inputFocused = true;
    },

    onInputFocusOut(){
      this.blurHead = false;
      this.inputFocused = false;
    },

    onSearchInput(text){
      this.searchInput = text;
    },

    getLocation(){
      return window.location.pathname;
    },

    SearchersNameShowed(){
      return !document.body.classList.contains('search');
    },

    getSearchSystems() {
      return Object.keys(this.search_systems);
    },
    onSearchSubmit() {
      window.location.href = '/search?'+ new URLSearchParams({
        search: this.searchInput,
      }).toString();
    },
  },
  watch: {
    blurHead() {
      let el = document.getElementsByClassName('ex')
      if (el.length) {
        el = el[0]
        if (this.blurHead) {
          el.classList.add('blur')
        } else {
          el.classList.remove('blur')
        }
      }
    },
    inputFocused(){
      if(this.inputFocused){
        document.body.classList.add("mobile_input_focused");
      }else{
        document.body.classList.remove("mobile_input_focused");
      }
    }
  },
  mounted() {
    if(this.$route.query.search){
      this.searchInput = this.$route.query.search;
      this.onSearchSubmit();
    }
  },
  components: {
    SearchForm
  },
}
</script>

<style lang="scss">

.mobile_input_focused{
  overflow: hidden;
}

.banner, .banner_text {
  transition: filter .4s ease-in-out;
  filter: blur(0);
}

.mobile_input_focused .center_block {
  .banner, .banner_text {
    filter: blur(10px);
  }
}

.search-field{
  padding-top: 20px;
}
.banner_text{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  .thumb.shine{
    display: flex;
    flex-direction: column;
    align-items: center;

    img{
      max-width: 70px;
      background: white;
      border-radius: 8px;
    }
  }

  @media screen and (max-width: 480px){
    .thumb.shine{
      width: 26%;
      min-width: auto;
      margin: 10px;
    }
  }

}

.center_block{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  max-width: 800px;
  width: 100%;

  display: flex;
  flex-direction: column;
}

.banner_text{
  margin: 20px 0;
}
@media screen and (max-width: 768px){
  .banner_text{
    margin: 20px 20px;
  }
}

.first-text {
  font-weight: 600;
}
</style>
